import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { FDLozenge, FDStack } from '@facet-wealth/design';

const PlanningVersionLozenge = ({
  resource,
}) => {
  const planningVersion = Number(resource.attr('planningVersion')).toPrecision(2);

  return (
    <FDStack alignItems={'center'}>
      <FDLozenge color={planningVersion === '2.0' ? 'info' : 'error'} label={planningVersion} size={'lg'} />
    </FDStack>
  );
};

PlanningVersionLozenge.defaultProps = {};

PlanningVersionLozenge.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { PlanningVersionLozenge };
